import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import Carregando from "../../Componentes/Carregando";
import MenuPrinc from "../../Componentes/MenuPrinc";
import {
  MascaraCNPJ,
  AlertForm,
  AlertConfirm,
  AlertRedirect,
} from "../../Componentes/Funcoes";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputMask from "react-input-mask";
import { withStyles } from "@material-ui/core/styles";
import { URLBunge } from "../../Componentes/Config";
import {
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  FormPesquisa,
  ClienteProdutoSelecionado,
  CampoFormCadastro,
  DescCampo,
  Clear,
  BotaoEnviarPesquisa,
} from "../../Estilos";

const GreenRadio = withStyles({
  root: {
    color: "#DDDDDD",
    "&$checked": {
      color: "#FFFFFF",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

function Recompra1500(props) {
  const history = useHistory();
  const location = useLocation();

  const [Loading, setLoading] = useState(true);
  const [Cliente, setCliente] = useState("");
  const [RealizouCompra, setRealizouCompra] = useState("");
  const [PerguntaPesquisa, setPerguntaPesquisa] = useState(0);
  const [RespostaPesquisa, setRespostaPesquisa] = useState(0);
  const [ListarPerguntasFilhas, setListarPerguntasFilhas] = useState([]);
  const [ListarPerguntasPesquisaCompleta, setListarPerguntasPesquisaCompleta] =
    useState([]);
  const [c_obs, setc_obs] = useState("");
  const c_token = localStorage.getItem("c_token");
  const c_cpf = localStorage.getItem("c_cpf");

  function MostraOpcoesResposta() {
    if (PerguntaPesquisa === 15) {
      return (
        <>
          <CampoFormCadastro>
            <select
              value={RespostaPesquisa}
              onChange={(e) => setRespostaPesquisa(e.target.value)}
            >
              <option value={0} disabled selected>
                Selecione uma opção
              </option>
              {ListarPerguntasFilhas.length > 0 &&
                ListarPerguntasFilhas.map((item, index) => {
                  return (
                    <>
                      {" "}
                      <option value={item.value}>{item.label}</option>{" "}
                    </>
                  );
                })}
            </select>
          </CampoFormCadastro>
        </>
      );
    }

    if (PerguntaPesquisa === 17) {
      return (
        <>
          <CampoFormCadastro>
            <select
              value={RespostaPesquisa}
              onChange={(e) => setRespostaPesquisa(e.target.value)}
            >
              <option value={0} disabled selected>
                Selecione uma opção
              </option>
              {ListarPerguntasFilhas.length > 0 &&
                ListarPerguntasFilhas.map((item, index) => {
                  return (
                    <>
                      {" "}
                      <option value={item.value}>{item.label}</option>{" "}
                    </>
                  );
                })}
            </select>
          </CampoFormCadastro>
        </>
      );
    }

    if (PerguntaPesquisa === 16) {
      // Cliente com dívida - problema de crédito
      return;
    }

    if (PerguntaPesquisa === 18) {
      // Cliente fechado
      return;
    }

    if (PerguntaPesquisa === 19) {
      return (
        <>
          <CampoFormCadastro>
            <select
              value={RespostaPesquisa}
              onChange={(e) => setRespostaPesquisa(e.target.value)}
            >
              <option value={0} disabled selected>
                Selecione uma opção
              </option>
              {ListarPerguntasFilhas.length > 0 &&
                ListarPerguntasFilhas.map((item, index) => {
                  return (
                    <>
                      {" "}
                      <option value={item.value}>{item.label}</option>{" "}
                    </>
                  );
                })}
            </select>
          </CampoFormCadastro>

          {RespostaPesquisa === 30 ? (
            <CampoFormCadastro>
              <input
                onChange={(event) => setc_obs(event.target.value)}
                value={c_obs}
                id="c_obs"
                name="c_obs"
                type="text"
                placeholder="Observações"
                className="CampoForm CampoFormLogin"
                as={InputMask}
                mask=""
              />
            </CampoFormCadastro>
          ) : null}
        </>
      );
    }
    if (PerguntaPesquisa === 20) {
      // Cliente comprou da concorrência
      return (
        <CampoFormCadastro>
          <input
            onChange={(event) => setc_obs(event.target.value)}
            value={c_obs}
            id="c_obs"
            name="c_obs"
            type="text"
            placeholder="Observações"
            className="CampoForm CampoFormLogin"
            as={InputMask}
            mask=""
          />
        </CampoFormCadastro>
      );
    }
  }

  function EnviarPesquisa(event) {  
    event.preventDefault();
    let valida = false;

    var rawx = JSON.stringify({
      lojaId: Cliente.id,
      CnpjParticipanteId: Cliente.chaveId,
      compra: RealizouCompra,
      listaSuspensaId:
        RespostaPesquisa === 0 ? PerguntaPesquisa : RespostaPesquisa,
      observacao: c_obs,
    });

    if (RealizouCompra === "false") {
      if (PerguntaPesquisa === 0) {
        AlertForm("Você precisa escolher uma opção");
        valida = true;
        return;
      }

      if (PerguntaPesquisa === 15 && RespostaPesquisa === 0) {
        AlertForm("Você precisa escolher uma opção");
        valida = true;
        return;
      }

      if (PerguntaPesquisa === 17 && RespostaPesquisa === 0) {
        AlertForm("Você precisa escolher uma opção");
        valida = true;
        return;
      }

      if (PerguntaPesquisa === 19 && RespostaPesquisa === 0) {
        AlertForm("Você precisa escolher uma opção");
        valida = true;
        return;
      }

      if (
        (PerguntaPesquisa === 20 && c_obs === "") ||
        (PerguntaPesquisa === 19 && c_obs === "")
      ) {
        AlertForm("O campo observações é obrigatório!");
        valida = true;

        return;
      }
    }

    if (!valida === true) {
      setLoading(true);

      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + c_token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        lojaId: Cliente.id,
        CnpjParticipanteId: Cliente.chaveId,
        compra: RealizouCompra === "false" ? false : true,
        listaSuspensaId:
          RespostaPesquisa === 0 ? PerguntaPesquisa : RespostaPesquisa,
        observacao: c_obs,
        tipoPesquisaId: 6,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${URLBunge}/api/Pesquisa/CadastrarRespostasListaSuspensa`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.sucesso === true) {
            setLoading(false);
            AlertRedirect(result.mensagem, 'BonificacaoeRecompra1500', history);          
          } else {
            AlertForm("Algo deu errado", result.mensagem);
            setLoading(false);
          }         
          // history.push("/BonificacaoeRecompra1500")
        })
        .catch((error) => console.log("error", error));
    }
  }

  useEffect(() => {
    setCliente(location.state.item);
    console.log(location.state.item);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 350);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + c_token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Pesquisa/ListarPerguntasPesquisa/6`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso === true) {
          setListarPerguntasPesquisaCompleta(result.listaPais);
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  useEffect(() => {
    if (PerguntaPesquisa !== 0) {
      var Filtro = ListarPerguntasPesquisaCompleta.filter(function (arr) {
        return arr.value == PerguntaPesquisa;
      });
      setListarPerguntasFilhas(Filtro[0].listaFilhas);
    }
  }, [PerguntaPesquisa]);

  useEffect(() => {
    setc_obs("");
    setRespostaPesquisa(0);
  }, [PerguntaPesquisa]);

  return (
    <>
      {Loading === true ? <Carregando /> : null}
      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Recompra 1.500 Lojas</TitNoticias>
            <h5>Dados do cliente</h5>
            <FormPesquisa onSubmit={EnviarPesquisa}>
              {Cliente != "" && (
                <ClienteProdutoSelecionado>
                  <div className={"NomeCliente"}>{Cliente.nome}</div>
                  <div className={"CNPJSAP"}>
                    <span>CPNJ</span> {MascaraCNPJ(Cliente.cnpj)}
                  </div>
                  <div className={"CNPJSAP"}>
                    <span>SAP</span> {Cliente.sap}
                  </div>
                  <div className={"CNPJSAP"}>
                    <span style={{ width: "70px" }}>PRODUTO</span>{" "}
                    {Cliente.produto}
                  </div>
                 
                  <div
                    className={"BtAlterar"}
                    onClick={() => history.push("/BonificacaoeRecompra1500")}
                  >
                    VOLTAR
                  </div>
                </ClienteProdutoSelecionado>
              )}

              <CampoFormCadastro>
                <DescCampo>Cliente realizou recompra?</DescCampo>
                <aside className="RadioDesafio">
                  <RadioGroup
                    style={{ flexDirection: "inherit" }}
                    aria-label="gender"
                    name="gender1"
                    value={RealizouCompra}
                    onChange={(e) => { setRealizouCompra(e.target.value)}}
                  >
                    <FormControlLabel
                      value={"true"}
                      control={<GreenRadio color="primary" />}
                      label={"SIM"}
                    />
                    <FormControlLabel
                      value={"false"}
                      control={<GreenRadio color="primary" />}
                      label={"NÃO"}
                    />
                  </RadioGroup>
                </aside>
              </CampoFormCadastro>
              <Clear />

              {RealizouCompra === "" ? null : RealizouCompra ===
                "true" ? null : (
                <>
                  <CampoFormCadastro>
                    <select
                      name={"c_perguntas"}
                      id={"c_perguntas"}
                      onChange={(e) =>
                        setPerguntaPesquisa(Number(e.target.value))
                      }
                    >
                      <option value={0} disabled selected>
                        Selecione uma opção
                      </option>
                      {ListarPerguntasPesquisaCompleta.map((item, index) => {
                        return (
                          <>
                            {" "}
                            <option value={item.value}>
                              {item.label}
                            </option>{" "}
                          </>
                        );
                      })}
                    </select>
                  </CampoFormCadastro>
                </>
              )}

              {RealizouCompra === "true"
                ? null
                : PerguntaPesquisa === 0
                ? null
                : MostraOpcoesResposta()}

              <Clear />
              {RealizouCompra !== "" && (
                <BotaoEnviarPesquisa type="submit">
                  ENVIAR PESQUISA
                </BotaoEnviarPesquisa>
              )}
              <Clear />
            </FormPesquisa>{" "}
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default Recompra1500;
